import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { droppedFiles } from './drop'
import { useUploads } from './UploadsProvider'

/**
 * Files dropped anywhere in the platform start an upload job into the private library and open it
 * (UPL-01). Drop zones with a destination of their own handle their drops themselves.
 */
export function DropUploads() {
  const jobs = useUploads()
  const navigate = useNavigate()

  useEffect(() => {
    const over = (event: DragEvent) => {
      if (!event.dataTransfer?.types.includes('Files')) return
      event.preventDefault()
      event.dataTransfer.dropEffect = 'copy'
    }
    const drop = (event: DragEvent) => {
      if (event.defaultPrevented || !event.dataTransfer?.types.includes('Files')) return
      event.preventDefault()
      // The browser empties the drop after this event, so its files are taken now.
      const files = droppedFiles(event.dataTransfer)
      void openJob(
        navigate,
        files.then((chosen) => jobs.add(chosen)),
      )
    }
    window.addEventListener('dragover', over)
    window.addEventListener('drop', drop)
    return () => {
      window.removeEventListener('dragover', over)
      window.removeEventListener('drop', drop)
    }
  }, [jobs, navigate])

  return null
}

/** Opens the job once it exists, or the uploads page with the reason none was made. */
export async function openJob(navigate: ReturnType<typeof useNavigate>, job: Promise<{ id: string } | null>): Promise<void> {
  try {
    const made = await job
    await navigate(made ? `/uploads/${made.id}` : '/uploads', made ? undefined : { state: { error: 'nothing_chosen' } })
  } catch (error) {
    await navigate('/uploads', { state: { error: errorCode(error) } })
  }
}

const errorCode = (error: unknown) =>
  error !== null && typeof error === 'object' && 'code' in error && typeof error.code === 'string' ? error.code : 'unreadable'
